import { render } from "./GoodsQuantity.vue?vue&type=template&id=3395a95c&scoped=true"
import script from "./GoodsQuantity.vue?vue&type=script&lang=js"
export * from "./GoodsQuantity.vue?vue&type=script&lang=js"

import "./GoodsQuantity.vue?vue&type=style&index=0&id=3395a95c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3395a95c"]])

export default __exports__